<template>
  <div
    class="d-flex align-items-center mb-2"
    style="gap: 10px;"
  >
    <i class="mdi mdi-arrow-all handler mb-3" style="cursor: grab"></i>
    <template
      v-if="node.type === 'condition'"
    >
      <LmTreeSelect
        clearable
        placeholder="Condición"
        :options="conditionsOptions"
        v-model="node.expression"
      />
      <LmTreeSelect
        clearable
        placeholder="Validación"
        :options="validationsOptions"
        v-model="node.validation"
      />
      <LmTreeSelect
        clearable
        placeholder="Valor"
        :options="valuesOptions"
        v-model="node.value"
      />
    </template>
    <NodeRemoveBtn
      class="mb-3"
      :node="node"
      @node-remove="$emit('node-remove')"
    />
  </div>
</template>

<script>
import NodeRemoveBtn from '@/components/lmConditionalBuilder/components/NodeRemoveBtn'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  name: 'Node',
  props: {
    node: Object,
    conditionalsData: Object
  },
  components: {
    NodeRemoveBtn,
    LmTextInput,
    LmTreeSelect
  },
  computed: {
    conditionsOptions () {
      return this.conditionalsData?.conditionals?.map(el => {
        return {
          id: el.id,
          name: el.name
        }
      })
    },
    validationsOptions () {
      if (this.node.expression) {
        return this.conditionalsData?.conditionals?.find(el => {
          return el.id === this.node.expression.id
        })?.validations
      }
      return []
    },
    valuesOptions () {
      if (this.node.expression) {
        return this.conditionalsData?.conditionals?.find(el => {
          return el.id === this.node.expression.id
        })?.values
      }
      return []
    }
  }
}
</script>
